var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collect-container",on:{"click":_vm.toggleCollect}},[_c('img',{staticClass:"collect-icon",attrs:{"src":_vm.isCollected ? _vm.collectActIcon : _vm.collectIcon}}),_c('bi-button',{attrs:{"label":_vm.isCollected ? '取消常用' : '设为常用',"type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }